import { service } from './service'
import { config } from './config'
import type { RequestOption } from '@/types'

const { default_headers } = config

const request = (option: RequestOption) => {
  const { url, method, params, data, headersType, responseType } = option
  return service({
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    headers: {
      'Content-Type': headersType || default_headers
    }
  })
}

export default {
  get: <T = unknown>(option: Omit<RequestOption, 'method'>) => {
    return request({ method: 'get', ...option }) as Promise<T>
  },
  post: <T = unknown>(option: Omit<RequestOption, 'method'>) => {
    return request({ method: 'post', ...option }) as Promise<T>
  },
  delete: <T = unknown>(option: Omit<RequestOption, 'method'>) => {
    return request({ method: 'delete', ...option }) as Promise<T>
  },
  put: <T = unknown>(option: Omit<RequestOption, 'method'>) => {
    return request({ method: 'put', ...option }) as Promise<T>
  }
}
